import { useState, createContext, useContext } from "react";
const useSearchCntx = createContext();
const setSearchCntx = createContext();
export function SearchCntx({ children }) {
    const [stSearch, setStSearch] = useState({});
    return (
        <useSearchCntx.Provider value={stSearch}>
            <setSearchCntx.Provider value={setStSearch}>
                {children}
            </setSearchCntx.Provider>
        </useSearchCntx.Provider>
    )
}
export function UseSearch() {
    return useContext(useSearchCntx);
}
export function SetSearch() {
    return useContext(setSearchCntx);
}